/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { InvestmentStatusValues } from '../types/utils';
import { InvestmentID } from './investment-model';

export class UpdateInvestmentInput {
	id: InvestmentID = ''

	status?: InvestmentStatusValues
}